import React, { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import mainicon from "../assets/finalicon.svg";
import coloredshield from "../assets/shield-colored.svg";
import coloredeye from "../assets/eye-colored.svg";
import coloredgraph from "../assets/graph-colored.svg";
import phone from "../assets/phonehand.png";
import finalgirlai from "../assets/finalgirlai.png";
import verifysvg from "../assets/mainpageverif.svg";
import chatsvg from "../assets/chatsvg.svg";
import paperplanesvg from "../assets/paperplane.svg";
import privace from "../assets/privace.svg";
import alessiopng from "../assets/alessiopng.png";
import Star from "../components/star";
import blackicon from "./businesspages/businessassets/blackicon.svg";
import manonlaptopai from '../assets/manonlaptopai.png'
import womanfinalai from '../assets/womanaisweather.jpg'
import finaldarkicon from '../assets/FINALDARKLOGO.svg'
import customerExampleman from '../assets/aiCustomerIMGMan.png'
import customerExamplewoman from '../assets/aiCustomerIMGWOMAN.png'
import fivestarimgstack from '../assets/newfivestarstuck.svg'
import { Helmet } from "react-helmet-async";
import FullPageLoader from "../components/FullPageLoader";

import "../app.css";

export default function Mainpage({ selectedLanguage }) {
  const containerRef = useRef(null);
  const logos = useRef([]);
  const navigate = useNavigate();
const [isReady, setIsReady] = useState(false);



  const images = useMemo(
    () => [
      { src: verifysvg, size: 120, initialCenterX: 60, initialCenterY: 80, bgClass: "bg-redcircle" },
      { src: chatsvg, size: 110, initialCenterX: 220, initialCenterY: 120, bgClass: "bg-bluecircle" },
      { src: paperplanesvg, size: 115, initialCenterX: 40, initialCenterY: 160,bgClass: "bg-greencircle" },
      { src: privace, size: 124, initialCenterX: 340, initialCenterY: 190, bgClass: "bg-orangecircle" },
    ],
    [],
  );

  useEffect(() => {
    const container = containerRef.current;
    const elements = logos.current.filter((el) => el);
    if (!container || elements.length === 0) return;

    // Use a slightly lower speed for a "premium" feel
    const speeds = elements.map(() => ({
      x: (Math.random() > 0.5 ? 1 : -1) * 0.8,
      y: (Math.random() > 0.5 ? 1 : -1) * 0.8,
    }));

    let animationFrameId;

    const animate = () => {
      const containerRect = container.getBoundingClientRect();
      const { width, height } = containerRect;

      elements.forEach((el, i) => {
        const radius = el.offsetWidth / 2;
        // Always pull the latest center from dataset to stay in sync
        let cx = parseFloat(el.dataset.centerX) || images[i].initialCenterX;
        let cy = parseFloat(el.dataset.centerY) || images[i].initialCenterY;

        // 1. UPDATE POSITION
        cx += speeds[i].x;
        cy += speeds[i].y;

        // 2. WALL COLLISION (With "Snap-Back" to prevent escaping)
        if (cx - radius < 0) {
          cx = radius;
          speeds[i].x *= -1;
        } else if (cx + radius > width) {
          cx = width - radius;
          speeds[i].x *= -1;
        }

        if (cy - radius < 0) {
          cy = radius;
          speeds[i].y *= -1;
        } else if (cy + radius > height) {
          cy = height - radius;
          speeds[i].y *= -1;
        }

        // 3. LOGO-TO-LOGO COLLISION
        for (let j = i + 1; j < elements.length; j++) {
          const other = elements[j];
          const oRadius = other.offsetWidth / 2;
          let ocx =
            parseFloat(other.dataset.centerX) || images[j].initialCenterX;
          let ocy =
            parseFloat(other.dataset.centerY) || images[j].initialCenterY;

          const dx = ocx - cx;
          const dy = ocy - cy;
          const distance = Math.sqrt(dx * dx + dy * dy);
          const minDistance = radius + oRadius;

          if (distance < minDistance) {
            // --- THE "PERFECT" BOUNCE MATH ---

            // A. Normal Vector (The direction of the hit)
            const nx = dx / distance;
            const ny = dy / distance;

            // B. Static Resolution (Push them apart so they don't stick)
            const overlap = minDistance - distance;
            cx -= nx * (overlap / 2);
            cy -= ny * (overlap / 2);
            ocx += nx * (overlap / 2);
            ocy += ny * (overlap / 2);

            // Write the "other" logo's new position back to dataset immediately
            other.dataset.centerX = ocx.toString();
            other.dataset.centerY = ocy.toString();

            // C. Dynamic Resolution (The Elastic Bounce)
            // Calculate relative velocity
            const vrelX = speeds[i].x - speeds[j].x;
            const vrelY = speeds[i].y - speeds[j].y;

            // Calculate velocity along the normal (dot product)
            const dotProduct = vrelX * nx + vrelY * ny;

            // Only bounce if they are moving TOWARDS each other
            if (dotProduct < 0) {
              // Swap momentum (Impulse)
              speeds[i].x -= dotProduct * nx;
              speeds[i].y -= dotProduct * ny;
              speeds[j].x += dotProduct * nx;
              speeds[j].y += dotProduct * ny;
            }
          }
        }

        // 4. APPLY TO DOM
        el.dataset.centerX = cx.toString();
        el.dataset.centerY = cy.toString();
        el.style.transform = `translate(${cx - radius}px, ${cy - radius}px)`;
      });

      animationFrameId = requestAnimationFrame(animate);
    };

    animationFrameId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrameId);
  }, [images, isReady]);



useEffect(() => {
  // We give the browser 600ms to cache the fonts and the phone image 
  // while the user sees your spinning div.
  const timer = setTimeout(() => {
    setIsReady(true);
  }, 500); 

  return () => clearTimeout(timer);
}, []);

if (!isReady) {
  return <FullPageLoader />;
}

const mainPageSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "SoftwareApplication",
      "@id": "https://sitemanifest.com/#software",
      "name": "Sitemanifest",
      "url": "https://sitemanifest.com",
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Web",
      "founder": {
    "@type": "Person",
    "name": "Omar Getiashvili"
  },
"sameAs": [
        "https://crunchbase.com/organization/sitemanifest",
        "https://www.g2.com/products/sitemanifest/reviews",
        "https://saashub.com/sitemanifest"
      ],
      "description": "Sitemanifest is a high-performance review aggregator and social proof platform. It helps businesses automate customer testimonial collection and display verified reviews to increase conversion rates.",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD"
      }
    },
    {
      "@type": "Organization",
      "@id": "https://sitemanifest.com/#organization",
      "name": "Sitemanifest",
      "url": "https://sitemanifest.com",
      "logo": "https://sitemanifest.com/static/media/FINALDARKLOGO.c6c0cf71b299ff53c45dfa12750037b2.svg" 
    }
  ]
};

  return (
    <main className="menu transform -z-10 bg-[#f3f3f3] overflow-hidden pt-[50px] lg:pt-[64px] xl:pt-[68px] h-auto">
<Helmet>
      <script type="application/ld+json">{JSON.stringify(mainPageSchema)}</script>
  <title>Sitemanifest | Verified Reviews & Customer Testimonials</title>
  <meta 
    name="description" 
    content="Increase conversion with Sitemanifest, the high-integrity verified reviews platform. Capture authentic customer proof via WhatsApp, DMs, and Email without forced logins." 
  />

  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://sitemanifest.com" />

  {/* Social / Open Graph: The "Entity" signal */}
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://sitemanifest.com" />
  <meta property="og:title" content="Sitemanifest | High-Integrity Verified Reviews" />
  <meta property="og:description" content="Stop fake feedback. Build instant trust with our transparency-first verification protocol for reviews and testimonials." />
  <meta property="og:image" content="https://sitemanifest.com/og-image.png" />

  {/* Twitter: The "Viral" signal */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Sitemanifest | Verified Reviews Platform" />
  <meta name="twitter:description" content="Capture and display authentic customer feedback verified by identity. No more bots. Just real growth." />
</Helmet>

      {/* HERO SECTION */}
      <section className="w-full flex mt-[45px] 2xl:h-[400px] 2xl:mt-[70px] 2xl:max-w-[1440px] xs:pr-[16px] lg:px-[32px] xl:pl-[64px] 2xl:mx-auto lg:pr-[32px] 2xl:pl-[40px] xl:pr-[64px] xs:justify-between flex-col xs:flex-row-reverse items-center gap-[50px]">
        <div className="w-full ip:max-w-[380px]  lg:max-w-[450px] 2xl:max-w-[690px] xl:max-w-[580px] pt-[10px] 2xl:pt-[50px] lg:pt-[30px] relative px-[10px] flex flex-col">
  <div ref={containerRef} className="flex w-full flex-col relative gap-[5px]">
    
    {/* 1. ANIMATED LOGOS (Logic preserved - Clean Professional Cards) */}
    {images.map((logo, i) => (
      <div
        key={i}
        ref={(el) => (logos.current[i] = el)}
        className={`absolute rounded-2xl flex h-[65px] w-[65px] lg:w-[85px] lg:h-[85px] items-center justify-center z-[100] bg-white shadow-[0_10px_30px_rgba(0,0,0,0.06)] rounded-full select-none ${logo.bgClass}`}
        style={{
          transform: `translate(${logo.initialCenterX - logo.size / 2}px, ${logo.initialCenterY - logo.size / 2}px)`,
        }}
      >
        <img 
          src={logo.src} 
          alt="" 
          className="w-[30px] h-[30px] lg:w-[40px] lg:h-[40px] object-contain" 
        />
      </div>
    ))}

    {/* 2. REFINED GEOMETRIC BACKDROP (Technical & High-Contrast) */}
    <div className="flex flex-row items-end gap-[15px]">
      {/* THE ANCHOR - Your Requested Teal #1C6065 */}
      <div className="w-[280px] 2xl:w-[480px] 2xl:h-[140px] xl:w-[400px] xl:h-[110px] lg:w-[340px] lg:h-[90px] h-[80px] rounded-2xl bg-[#1C6065] shadow-2xl relative overflow-hidden">
         <div className="absolute top-0 left-0 w-full h-[1.5px] bg-gradient-to-r from-transparent via-white/20 to-transparent" />
      </div>
      
      {/* NEW ACCENT - Deep Graphite (Replacing the Mint) */}
      <div className="w-[70px] 2xl:w-[130px] 2xl:h-[130px] xl:w-[110px] xl:h-[110px] lg:w-[90px] lg:h-[90px] h-[70px] rounded-[24px] bg-two rotate-[15deg] shadow-[0_20px_40px_rgba(0,0,0,0.2)] flex items-center justify-center">
          {/* Subtle geometric detail */}
      </div>
    </div>

    <div className="flex flex-row items-center relative -mt-6">
      {/* THE GLASS SLAB - Metallic/Silver Hue */}
      <div className="ml-[20px] lg:ml-[40px] 2xl:w-[500px] 2xl:h-[80px] xl:w-[400px] xl:h-[65px] lg:w-[320px] lg:h-[55px] w-[270px] h-[50px] rounded-xl bg-white backdrop-blur-xl border border-white shadow-sm -skew-x-6"></div>
      
      {/* DECORATIVE CIRCLE - Soft Neutral Slate */}
 {/* THE MIRROR SLATE SLAB */}
<div className="ml-[20px] lg:ml-[40px] 2xl:w-[500px] 2xl:h-[80px] xl:w-[400px] xl:h-[65px] lg:w-[320px] lg:h-[55px] w-[270px] h-[50px] rounded-xl bg-gradient-to-br from-[#1e293b] via-[#475569] to-[#1e293b] backdrop-blur-2xl border-t border-l border-white/30 shadow-[inset_0_1px_1px_rgba(255,255,255,0.2),0_10px_20px_rgba(0,0,0,0.2)] -skew-x-6">
  {/* The "Mirror Reflection" Light Streak */}
  <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-transparent pointer-events-none"></div>
</div>

    </div>

    {/* 3. THE PHONE PREVIEW NESTED IN BASE CONTAINER */}
    <div className="flex flex-row items-center gap-[12px] relative mt-4">
      {/* MAIN BASE CARD - Clean White with Slate-to-Transparent Gradient */}
      <div className="ml-0 xl:ml-[20px] lg:w-[480px] xl:w-[580px] 2xl:w-[740px] 2xl:h-[140px] xl:h-[120px] lg:h-[110px] w-[360px] h-[100px] rounded-3xl bg-five border border-[#E2E8F0] relative overflow-visible shadow-[0_40px_70px_-15px_rgba(28,96,101,0.1)]">
        
            <div className="absolute lg:bg-[#1E7D6B] 2xl:w-[160px] 2xl:h-[320px] 2xl:bottom-[73px] 2xl:left-[310px] xl:left-[244px] xl:w-[127px] xl:bottom-[63px] xl:h-[257px] lg:bottom-[57px] lg:w-[115px] lg:h-[225px] lg:left-[205px] w-[96px] h-[195px] bottom-[48px] left-[169px] bg-transparent rounded-[12px] z-9">
                  <div className="flex flex-col w-full  h-full bg-[#1E7D6B] rounded-[12px]">
                    <div className="flex flex-row bg-white w-[85px] lg:w-[100px] xl:w-[110px] 2xl:w-[138px]  rounded-[4px] mx-auto items-center justify-between lg:px-[6px] px-[6px] 2xl:px-[8px]  xl:mt-[15px] 2xl:mt-[20px] 2xl:relative  lg:top-[2px] z-10 mt-[15px] h-[14px] lg:h-[16px] xl:h-[21px]">
                      <div className="flex  mt-[1px] flex-row gap-[3px] lg:gap-[5px] items-center">
                        <img
                          className="w-[7px] xl:w-[11px] xl:h-[11px] h-[7px] lg:w-[9px] lg:h-[10px] select-none"
                          src={finaldarkicon}
                          alt="logo"
                        />
                        <span className="font-staat text-[6px]  xl:text-[8px] lg:text-[7px] tracking-[1px] font-regular text-[#323232]">
                          sitemanifest
                        </span>
                      </div>

                      <div className="flex flex-col justify-between lg:w-[8px] xl:w-[12px] xl:h-[7.5px] lg:h-[5.5px] w-[6px] h-[4px]">
                        <div className="w-full bg-[#323232] h-[0.5px] lg:h-[0.8px] xl:h-[1.1px]"></div>
                        <div className="w-full bg-[#323232] h-[0.5px] lg:h-[0.8px] xl:h-[1.1px]"></div>
                        <div className="w-full bg-[#323232] h-[0.5px] lg:h-[0.8px] xl:h-[1.1px]"></div>
                      </div>
                    </div>

                    <div className="flex flex-col items-center w-full h-[110px] lg:h-[115px] 2xl:h-[153px] xl:h-[125px] bg-greentoblue relative overflow-hidden">
                      <div className="flex flex-col items-center gap-[6px] 2xl:mt-[8px] pt-[7px] z-10">
                        <p className="font-staat font-regular text-[6px] xl:text-[8px] lg:text-[7px] 2xl:tracking-[4px] 2xl:text-[8px] 2xl:max-w-[140px] tracking-[2px] text-center text-white">
                          Turn reviews into traffic, sales, and customer
                          loyalty.
                        </p>
                        <span className="font-staat font-regular text-[4px] xl:text-[6px] lg:text-[5px] 2xl:text-[7px] tracking-[1px] text-white opacity-80 text-center xl:max-w-[105px] max-w-[79px]">
                          Discover what the people who matter most are saying
                          about your brand.
                        </span>
                      </div>

                      <div className="flex flex-col items-center mt-[6px] gap-[7px] z-10">
                        <button className="w-[66px] xl:w-[95px] 2xl:w-[105px] 2xl:h-[19px] h-[12px] 2xl:text-[7px] xl:text-[6px] lg:h-[15px] lg:w-[75px] rounded-[2px] bg-white text-black text-[3px] lg:text-[4px] font-staat tracking-[1px] text-center">
                          register your business
                        </button>
                        <button className="w-[50px] h-[12px] xl:text-[6px] 2xl:h-[19px] 2xl:h-[17px] 2xl:text-[7px] xl:w-[75px] lg:h-[15px] lg:w-[60px] rounded-[2px] bg-white text-black text-[3px] lg:text-[4px] font-staat tracking-[1px] text-center">
                          log in
                        </button>
                      </div>
                    </div>

                    <div className="flex flex-col gap-[5px] lg:p-[6px] p-[5px] w-full h-[70px] 2xl:h-[125px] rounded-b-[2px] lg:rounded-b-[2px] 2xl:rounded-b-[10px] xl:h-[100px]  lg:h-[85px] bg-[#f3f3f3]">
                      <div className="flex flex-col gap-[3px] 2xl:px-[9px]">
                        <h3 className="text-[4px] font-staat tracking-[1px] xl:text-[6px] 2xl:text-[7px] lg:text-[5px] text-black">
                          Build more trust in your brand
                        </h3>
                        <h4 className="text-[3px] font-poppins font-regular lg:text-[4px] 2xl:text-[6px] xl:text-[5px] text-black tracking-[1px]">
                          Reviews help you build a stellar online presence right
                          where shoppers are researching their next purchase.
                        </h4>
                      </div>

                      <div className="flex flex-col gap-[3px] 2xl:px-[9px]">
                        <h3 className="text-[4px] font-staat tracking-[1px] 2xl:text-[7px] lg:text-[5px] xl:text-[6px] text-black">
                          Attract new customers
                        </h3>
                        <h4 className="text-[3px] font-poppins font-regular lg:text-[4px] 2xl:text-[6px] xl:text-[5px] text-black tracking-[1px]">
                          Turn more browsers into buyers by showcasing your
                          reviews across your site and marketing materials.
                        </h4>
                      </div>

                      
                    </div>
                  </div>
                </div>
              </div>
            <div
  className="absolute z-10 select-none overflow-hidden 
             w-[286px] 2xl:w-[463px] xl:w-[380px] lg:w-[336px]
             h-[500px] 2xl:h-[800px] /* Add explicit heights */
             left-[41px] lg:left-[55px] xl:left-[93px] 2xl:left-[125px] 
             bottom-0 
             [clip-path:inset(0_0_1px_0)] 2xl:[clip-path:inset(0_0_0.5px_0)]"
  style={{
    backgroundImage: `url(${phone})`,
    backgroundSize: 'contain',
    backgroundPosition: 'bottom center',
    backgroundRepeat: 'no-repeat'
  }}
  aria-hidden="true"
/>
            </div>
            
          </div>


        </div>





        <div className="flex flex-col items-center px-[16px] xs:items-start text-center xs:px-[32px] lg:px-0 xs:text-start max-w-[500px]">
     <h1 className="font-staat text-[40px] xs:text-[30px] lg:text-[42px] xl:text-[50px] leading-[1.1] text-[#1a1a1a] tracking-tight uppercase">
  INCREASE CONVERSION WITH <br className="hidden lg:block" />
  <span className="text-[#1C6065]">VERIFIED REVIEWS</span>
</h1>
          <p className="mt-6 font-poppins text-[14px] xs:max-w-[320px] lg:max-w-full xs:text-[12px] lg:text-[14px] xl:text-[16px] 2xl:text-[18px] text-gray-600 font-light leading-relaxed">
            Consumers rely on Sitemanifest daily to research and compare reputable brands. 
            Ensure your business stands out exactly where potential customers are already conducting their vital purchase research.
          </p>
          <button 
            onClick={() => navigate("/business/signup")}
            className="mt-10 group relative inline-flex items-center justify-center px-10 py-4 xs:py-3 lg:py-4 font-poppins font-medium tracking-tighter text-white bg-[#1C6065] overflow-hidden rounded-md cursor-pointer transition-all duration-300 active:scale-95"
            aria-label="Register your business for conversion growth"
          >
            <span className="absolute inset-0 w-full h-full bg-gradient-to-br from-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></span>
            <span className="relative text-[14px] xs:text-[12px] lg:text-[14px] uppercase tracking-widest">Register your business</span>
          </button>
        </div>
      </section>

      {/* CORE PROTOCOLS */}
      <section className="mt-[80px] 2xl:max-w-[1440px] mx-auto 2xl:mt-[150px] pb-[100px] px-[16px] xs:px-[32px] 2xl:px-[48px] xl:px-[64px]">
        <div className="mb-[80px]">
          <h2 className="font-staat text-center lg:text-start text-[40px] lg:text-[64px] tracking-[1px] text-[#111111] leading-none mb-6">
            CORE <span className="text-[#08696D]">PROTOCOLS</span>
          </h2>
          <div className="w-[100px] h-[2px] bg-[#08696D] lg:mr-auto lg:mx-0 mx-auto"></div>
        </div>

        <div className="flex flex-col gap-[100px] lg:gap-[150px]">
          {[
            { id: '01', title: 'Zero-Friction Growth', text: "Stop losing 70% of your feedback to the 'Sign-in Wall.' Our Forensic Guest Protocol allows email invited customers to submit reviews instantly via email-token—no account, no proof, no password, no friction.", icon: paperplanesvg, tag: 'VELOCITY', color: 'green' },
            { id: '02', title: 'Conversation to Conversion', text: "Don't let your best feedback die in a screenshot. We turn private WhatsApp and DM praise into verified public equity. We validate your digital receipts so your reputation works for you 24/7.", icon: chatsvg, tag: 'LIQUIDITY', color: 'blue' },
            { id: '03', title: 'Verified Interactions Only', text: 'We’ve eliminated the "open review" flaw for the non-invited reviewers. On SiteManifest, documented proof of service isn\'t a suggestion—it’s the **barrier to entry**. No history, no voice. No bots, no sabotage. Just the truth.', icon: verifysvg, tag: 'INTEGRITY', color: 'red' },
            { id: '04', title: 'Controlled Visibility, Zero Noise', text: "We shield your brand from open-web chaos. By blocking scrapers and automated bots, we maintain a private, high-integrity repository of truth. No spam, no noise—just verified reputation.", icon: privace, tag: 'PRIVACY', color: 'orange' }
          ].map((item) => (
            <article key={item.id} className="flex flex-col lg:flex-row gap-[40px] lg:gap-[100px] items-center">
              <div className="flex-shrink-0 relative">
                <div className={`w-[140px] h-[140px] lg:w-[180px] lg:h-[180px] bg-${item.color}circle rounded-full flex items-center justify-center relative z-10 shadow-xl`}>
                  <img src={item.icon} className="w-[50px] lg:w-[70px]" alt="" />
                </div>
                <div className={`absolute top-[-20px] left-[-20px] w-full h-full bg-${item.color}ballfirst/20 rounded-full blur-2xl`}></div>
              </div>
              <div className="max-w-[700px] flex flex-col">
                <span className={`font-staat text-[18px] lg:text-start text-center text-${item.color}ballfirst tracking-[4px]`}>{item.id} / {item.tag}</span>
                <h3 className="font-staat text-center lg:text-start text-[32px] lg:text-[48px] text-black mt-2 mb-6 tracking-tight leading-tight">{item.title}</h3>
                <p className="font-poppins text-center text-[16px] lg:text-start lg:text-[20px] text-gray-700 leading-relaxed font-light">{item.text}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* TESTIMONIAL ECOSYSTEM */}
      <section className="w-full h-auto pb-[60px] bg-white mt-[140px] xs:mt-[100px] relative">
        <div className="w-full mx-auto 2xl:max-w-[1440px] relative lg:px-[32px] 2xl:px-[64px] px-[16px]">
          <aside className="absolute -top-[120px] left-1/2 -translate-x-1/2 xs:left-auto xs:right-[32px] xs:translate-x-0 xs:-top-[50px] lg:right-[64px] bg-[#1C6065] h-[280px] lg:h-[320px] w-[92%] max-w-[345px] lg:max-w-[410px] p-[25px] rounded-[12px] shadow-2xl z-10">
            <div className="relative h-full w-full flex flex-col">
              <span className="text-[13px] lg:text-[15px] font-staat text-white tracking-[2px] uppercase leading-tight z-20">Your happiness is our<br/>greatest motivation!</span>
              <img className="w-[75px] h-[75px] lg:w-[95px] lg:h-[95px] absolute top-[75px] left-0 rounded-[7px] shadow-lg z-30 object-cover" src={finalgirlai} alt="Satisfied Customer" /> 
              <img className="w-[90px] h-[70px] lg:w-[130px] lg:h-[100px] absolute top-[100px] right-[-10px] rounded-[10px] z-10 object-cover" src={manonlaptopai} alt="Business Professional" />
              <img className="w-[80px] h-[80px] lg:w-[100px] lg:h-[100px] absolute bottom-[-10px] left-[30%] rounded-[12px] shadow-2xl z-40 object-cover" src={womanfinalai} alt="Verified Reviewer" />
            </div>
          </aside>

          <div className="flex flex-col gap-[20px] pt-[180px] xs:pl-[32px] xl:px-[32px] 2xl:px-0 xs:pt-[50px] lg:pt-[60px] items-center xs:items-start">
            <div className="flex items-center gap-[12px]">
              <img className="w-[24px] h-[24px]" src={blackicon} alt="SiteManifest Icon" />
              <span className="font-staat text-[#323232] tracking-[3px] text-[18px]">SITEMANIFEST</span>
            </div>
            <p className="font-poppins text-[13px] lg:text-[15px] xl:text-[16px] max-w-[340px] 2xl:max-w-[750px] xs:max-w-[45%] text-[#323232]/90 font-light leading-relaxed text-center xs:text-start">
Sitemanifest is a high-integrity ecosystem for verified testimonials. We go beyond simple stars, transforming real customer interactions into sovereign trust assets. Securely index and display your brand’s truth through a third-party registry designed for total transparency and maximum conversion.
            </p>
            <button onClick={() => navigate("/about-us")} className="w-[140px] lg:w-[160px] h-[40px] rounded-[4px] bg-[#1C6065] text-white font-poppins text-[12px] tracking-[1px] hover:bg-[#154a4e] transition-colors shadow-md">About Us</button>
          </div>
        </div>
      </section>

      {/* LIVE INTERFACE PREVIEW SECTION */}
      <section className="flex flex-col 2xl:max-w-[1440px] 2xl:mx-auto mt-[40px] px-[16px] xs:px-[32px] w-full">
        <div className="flex flex-col xs:flex-row lg:flex-col xl:mt-[15px] xl:flex-row lg:justify-start xs:justify-between">

          <div className="phone lg:pb-[20px] max-w-[300px] lg:max-w-[560px] mx-auto lg:mx-auto xs:mx-0 px-[12px] flex flex-col w-full lg:h-auto h-[430px] bg-white border relative border-[4px] border-[#4B4B4B] rounded-[12px] mt-[20px]">

            <div className="w-full px-[12px] shadow-sm items-center flex flex-row z-10 justify-between lg:h-[45px] lg:mt-[10px] h-[40px] mt-[10px] shadow-sm bg-white rounded-[8px]">

              <div className="flex flex-row items-center gap-[12px]">
                <img className="w-[18px]" src={finaldarkicon} alt="" />
                <span className="text-[#323232] font-staat tracking-[2px] text-[14px]">SITEMANIFEST</span>
              </div>

              <img className="w-[28px] h-[28px] rounded-full object-cover" src={customerExampleman} alt="Profile" />
            </div>

            <div className="flex mt-[12px] flex-col">
              <div className="flex flex-row justify-around lg:justify-start items-center gap-[12px]">
                <img className="w-[60px] rounded-[4px] lg:w-[80px]" src={alessiopng} role="presentation" alt="" />


   {/* WRAPPER - Centering the stack */}
<div className="relative flex items-center justify-center lg:w-[200px]  w-[150px] h-[80px]">
  

  <div className="absolute w-[120px] lg:w-[160px] lg:h-[75px] h-[55px] bg-[#f3f4f6] rounded-[12px] -rotate-[4deg] " />

  


  <div className="relative w-[120px] lg:w-[160px] lg:h-[75px] h-[55px] rounded-[10px] overflow-hidden bg-white ">
    
    {/* THE SNAKE ANIMATION */}
    <div 
      className='absolute inset-[-150%] animate-spin-slow' 
      style={{ background: 'conic-gradient(from 0deg, transparent 75%, #3EBAA2)' }} 
    />

    {/* THE WHITE CORE (The Mask) */}
    <div className="absolute px-[6px] inset-[1.5px] bg-white rounded-[9px] z-10 flex ">
    

        <div className="flex flex-col w-full justify-between gap-[8px] py-2">
         <div className="flex flex-col w-full gap-[1px]">
            <span className="text-[6px] lg:text-[8px] font-poppins font-semibold tracking-[1px] text-[#1a1a1a]">Alessio Wagner</span> 

            <img className="w-[48px] lg:w-[64px]" src={fivestarimgstack} alt="" />
          </div>  



          <div className="w-full flex flex-row  justify-between">
            <div className="flex flex-col">
              <span className="text-[4px] lg:text-[6px] font-poppins font-regular tracking-[1px] text-gray-400 font-bold">MANIFESTSCORE</span>
              <span className="text-[6px] ip:text-[6px] lg:text-[8px] font-poppins font-semibold text-[#3EBAA2] leading-none " >4.9</span>

            </div>

            <div className="flex flex-col">
              <span className="text-[4px] lg:text-[6px]  font-poppins font-regular tracking-[1px] text-gray-400 font-bold">REVIEWS</span>
              <span className="text-[6px] ip:text-[6px] lg:text-[8px] font-poppins font-semibold text-[#3EBAA2] leading-none items-end text-end" >252</span>
            </div>

          </div> 

        </div>
    </div>
  </div>
</div>
  <div className="lg:flex flex-col items-center gap-[6px] ml-auto hidden">
            <p className='font-noto text-[10px] lg:text-[12px] lg:w-[140px] text-center w-[100px] font-regular mx-auto  text-[#1a1a1a]' >How would you rate <span className="text-[#3EBAA2]">Alessio Wagner?</span></p>
            
            <div className="flex flex-row gap-[3px]">
          {[...Array(5)].map((_, i) => <Star key={i} bgColor={'bg-[#e4e4e4]'} boxwidth="w-[20px]" boxheight="h-[20px]" width="w-[12px]" />)}

            </div>

        </div>
 </div>     
        <div className="flex flex-col items-center  gap-[6px] lg:hidden">
            <p className='font-noto text-[10px] text-center w-[100px] font-regular mx-auto mt-[15px] text-[#1a1a1a]' >How would you rate <span className="text-[#3EBAA2]">Alessio Wagner?</span></p>
            
            <div className="flex flex-row gap-[3px]">
          {[...Array(5)].map((_, i) => <Star key={i} bgColor={'bg-[#e4e4e4]'} boxwidth="w-[20px]" boxheight="h-[20px]" width="w-[12px]" />)}

            </div>

        </div>


            </div>
            
        <div className="flex w-full flex-col xl:mt-[40px] lg:mx-auto lg:max-w-[340px] px-[12px] h-auto gap-[12px] mt-[20px]">
          <div className="flex flex-row items-center gap-[15px]">
            <div className="w-[24px] h-[24px] rounded-full">
              <img className="w-full h-full rounded-full object-cover" src={customerExamplewoman} role="presentation" alt="Profile" />
            </div>
            <span className="font-poppins text-[8px] font-regular text-[#111111]">Maria J.</span>

          </div>
            <img className="w-[80px]" src={fivestarimgstack} alt="" />

          <div className="flex flex-col gap-[10px]">
            <span className="font-poppins text-[8px] font-semibold text-[#111111]">Best decision for my brand!</span>

            <span className="font-poppins text-[8px] font-regular text-[#111111]">I was honestly worried it would be way too complicated to prove to my new customers that my reviews are 100% real, but Sitemanifest made the whole process so easy. Everything was incredibly smooth from start to finish and the support team was there to help me out with every single question I had along the way.</span>
          </div>
        </div>

            
          </div>

          <div className="flex flex-col gap-[20px] mt-[20px] xs:max-w-[350px] xl:gap-[60px] lg:max-w-full xs:justify-center xl:items-start lg:mx-auto items-center">
            <h2 className="font-staat text-[24px] lg:text-6xl tracking-[1px] text-[#11111] text-center xl:text-start leading-[28px]">
              Build an <span className="text-[#1C6065]">Unshakeable</span> <br/> Online Presence
            </h2>
            <p className="font-poppins text-sm lg:text-lg text-gray-600 lg:text-start max-w-lg lg:max-w-[553px] text-center">
              Every interaction is an opportunity to prove your value. We help you capture, verify, and display real customer experiences.
            </p>
            <button onClick={() => navigate("/business/signup")} className="w-full sm:w-[260px] h-14 rounded bg-[#1C6065] text-white font-poppins font-semibold tracking-widest uppercase hover:scale-105 transition-all shadow-xl">
              Register your business
            </button>
          </div>
        </div>
      </section>

      {/* WIDGET SHOWCASE */}
     <section className="w-full mt-[60px] 2xl:max-w-[1440px] 2xl:mx-auto lg:mt-[120px] flex flex-col xl:items-start xl:px-[80px] items-center px-[18px] 2xl:px-[40px]">
  <div className="flex flex-col items-center xl:items-start xl:text-start text-center mb-[50px]">
    <h2 className="text-[28px] lg:text-[40px] tracking-tight font-poppins font-bold text-[#111111] leading-[1.1]">
      Proof, Right Where the <span className="text-[#1C6065]">Decision Happens.</span>
    </h2>
    <p className="mt-4 font-poppins text-[14px] lg:text-[16px] text-gray-600 max-w-[800px]">
      Don’t make your customers go looking for proof—bring it to them. Our lightweight widget embeds verified reputation directly into your sales flow.
    </p>
  </div>

  <div className="flex flex-col xl:items-center xl:mx-auto gap-[40px] w-full max-w-[1100px]">
    
    {/* ROW 1: THE LIGHT THEME */}
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 justify-items-center w-full">
      {/* Summary Card */}
      <div className="w-full max-w-[340px] min-h-[220px] p-5 ip:p-6 flex flex-col items-center justify-center rounded-[16px] border border-[#E5E5E5] bg-white transition-shadow">
        <span className="text-black font-poppins text-[22px] font-semibold">Great</span>
        <div className="flex flex-row flex-nowrap gap-1 h-[30px] my-3">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="flex-shrink-0">
              <Star boxwidth="w-[30px]" bgColor={'bg-five'} boxheight="h-[30px]" width="w-[18px]" />
            </div>
          ))}
        </div>
        <span className="text-gray-600 font-poppins text-[13px] mb-4 text-center">4.9 Based on 250 Reviews</span>
        <div className="flex items-center gap-2 pt-4 border-t w-full justify-center">
          <img className="w-[20px]" src={blackicon} alt="" />
          <span className="font-staat text-[16px] tracking-[3px]">SITEMANIFEST</span>
        </div>
      </div>

      {/* Detail Card 1 */}
      <div className="w-full max-w-[340px] min-h-[220px] p-5 ip:p-6 flex flex-col rounded-[16px] border border-[#E5E5E5] bg-white">
        <div className="flex justify-between items-center mb-3">
          <span className="font-poppins font-semibold text-[14px]">Luca F.</span>
          <span className="text-[10px] text-gray-400">JUL 19, 2025</span>
        </div>
        <div className="flex flex-nowrap gap-[2px] h-[20px] mb-3">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="flex-shrink-0">
              <Star boxwidth="w-[20px]" bgColor={'bg-five'} boxheight="h-[20px]" width="w-[12px]" />
            </div>
          ))}
        </div>
        <span className="font-poppins font-bold text-[14px] mb-1">Absolute Game Changer</span>
        <p className="text-[12px] text-gray-600 leading-snug">
          Hours of manual work have been replaced by a completely transformed workflow. This dashboard is fast, intuitive, and manages heavy data loads without any of the lag I experienced before.
        </p>
      </div>

      {/* Detail Card 2 */}
      <div className="hidden xl:flex w-full max-w-[340px] min-h-[220px] p-5 ip:p-6 flex-col rounded-[16px] border border-[#E5E5E5] bg-white">
        <div className="flex justify-between items-center mb-3">
          <span className="font-poppins font-semibold text-[14px]">Sophia P.</span>
          <span className="text-[10px] text-gray-400">FEB 21, 2025</span>
        </div>
        <div className="flex flex-nowrap gap-[2px] h-[20px] mb-3">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="flex-shrink-0">
              <Star boxwidth="w-[20px]" bgColor={'bg-five'} boxheight="h-[20px]" width="w-[12px]" />
            </div>
          ))}
        </div>
        <span className="font-poppins font-bold text-[14px] mb-1">Seamless and Professional</span>
        <p className="text-[12px] text-gray-600 leading-snug">
          Transitioning to this platform was our best decision this year. The polished UI builds massive client confidence, while the intuitive design makes navigation a breeze.
        </p>
      </div>
    </div>

    {/* ROW 2: THE DARK THEME */}
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 justify-items-center w-full">
      {/* Summary Card Dark */}
      <div className="w-full max-w-[340px] min-h-[220px] p-5 ip:p-6 flex flex-col items-center justify-center rounded-[16px] bg-[#1A1A1A]">
        <span className="text-white font-poppins text-[22px] font-semibold">Great</span>
        <div className="flex flex-row flex-nowrap h-[30px] gap-1 my-3">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="flex-shrink-0">
              <Star boxwidth="w-[30px]" bgColor={'bg-five'} boxheight="h-[30px]" width="w-[18px]" />
            </div>
          ))}
        </div>
        <span className="text-gray-400 font-poppins text-[13px] mb-4 text-center">4.9 Based on 250 Reviews</span>
        <div className="flex items-center gap-2 pt-4 border-t border-gray-700 w-full justify-center">
          <img className="w-[20px]" src={mainicon} alt="" />
          <span className="font-staat text-[16px] tracking-[3px] text-white">SITEMANIFEST</span>
        </div>
      </div>

      {/* Detail Card Dark 1 */}
      <div className="w-full max-w-[340px] min-h-[220px] p-5 ip:p-6 flex flex-col rounded-[16px] bg-[#1A1A1A]">
        <div className="flex justify-between items-center mb-3">
          <span className="font-poppins font-semibold text-[14px] text-white">Emma D.</span>
          <span className="text-[10px] text-gray-500">March 4, 2026</span>
        </div>
        <div className="flex flex-nowrap gap-[2px] h-[20px] mb-3">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="flex-shrink-0">
              <Star boxwidth="w-[20px]" bgColor={'bg-five'} boxheight="h-[20px]" width="w-[12px]" />
            </div>
          ))}
        </div>
        <span className="font-poppins font-bold text-[14px] mb-1 text-white">Highly recommend for pros</span>
        <p className="text-[12px] text-gray-400 leading-snug">
          If you care about efficiency, you need this. The automation features alone are worth the price. It’s rare to find a tool that balances deep technical power with a user-friendly design.
        </p>
      </div>

      {/* Detail Card Dark 2 */}
      <div className="hidden xl:flex w-full max-w-[340px] min-h-[220px] p-5 ip:p-6 flex-col rounded-[16px] bg-[#1A1A1A]">
        <div className="flex justify-between items-center mb-3">
          <span className="font-poppins font-semibold text-[14px] text-white">Roberto N.</span>
          <span className="text-[10px] text-gray-500">Jan 15, 2026</span>
        </div>
        <div className="flex flex-nowrap gap-[2px] h-[20px] mb-3">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="flex-shrink-0">
              <Star boxwidth="w-[20px]" bgColor={'bg-five'} boxheight="h-[20px]" width="w-[12px]" />
            </div>
          ))}
        </div>
        <span className="font-poppins font-bold text-[14px] mb-1 text-white">Supporto e qualità eccellenti</span>
        <p className="text-[12px] text-gray-400 leading-snug">
          Oltre alla piattaforma che funziona a meraviglia, devo fare un plauso all'assistenza. Hanno risposto a ogni mio dubbio in tempo reale. È raro trovare un servizio così curato nei minimi dettagli.
        </p>
      </div>
    </div>
  </div>
</section>

      {/* SYSTEM INTEGRITY PROTOCOLS GRID */}
      <section className="mt-[80px] 2xl:mt-[150px] pb-[100px] 2xl:px-[80px] px-[16px] xs:px-[32px] xl:px-[64px]">
        <div className="2xl:max-w-[1340px] mx-auto">
          <div className="mb-[60px] lg:mb-[100px]">
            <h2 className="font-staat text-[32px] lg:text-[52px] tracking-[1.5px] text-black leading-none mb-4">
              SYSTEM INTEGRITY <span className="text-[#1C6065]">PROTOCOLS</span>
            </h2>
            <p className="font-poppins font-light text-[14px] lg:text-[18px] text-gray-500 max-w-[600px]">
              We don't just host reviews; we engineer trust through a multi-layered verification architecture.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-[20px] xl:gap-[30px]">
            {[
              { title: 'AI VERIFICATION', text: 'Our system analyzes fraud signals in real-time—checking for suspicious patterns.', icon: coloredshield, status: 'ACTIVE' },
              { title: 'TRANSPARENT MODERATION', text: 'Every flagged review receives human verification. No black box algorithms.', icon: coloredeye, status: 'HUMAN VERIFIED' },
              { title: 'BEHAVIORAL ANALYSIS', text: 'We track reviewer patterns to neutralize paid campaigns and bot spikes.', icon: coloredgraph, status: 'NETWORK SENTRY' }
            ].map((card, i) => (
              <article key={i} className="group bg-[#F8F8F8] border-t-4 border-[#1C6065] p-8 lg:p-10 flex flex-col h-full hover:bg-white hover:shadow-2xl transition-all duration-500">
                <div className="mb-8 relative w-[60px] h-[60px] flex items-center justify-center">
                  <div className="absolute inset-0 bg-tealball/10 rounded-full group-hover:scale-150 transition-transform"></div>
                  <img className="w-full z-10" src={card.icon} alt={card.title} />
                </div>
                <h3 className="font-staat text-[24px] xl:text-[28px] text-black mb-4 tracking-wider">{card.title}</h3>
                <p className="font-poppins font-light text-[14px] xl:text-[16px] text-gray-600 leading-relaxed mb-6">{card.text}</p>
                <div className="mt-auto pt-6 border-t border-gray-200 flex items-center justify-between">
                  <span className="text-[10px] font-staat tracking-widest text-[#1C6065]">STATUS: {card.status}</span>
                  <div className="w-2 h-2 rounded-full bg-[#1C6065] animate-pulse"></div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}